import React from 'react';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Filtrar errores de DOM que no afectan la funcionalidad
    const ignorableErrors = [
      'removeChild',
      'insertBefore',
      'appendChild',
      'NotFoundError'
    ];
    
    const isIgnorable = ignorableErrors.some(msg => 
      error?.message?.includes(msg) || error?.toString()?.includes(msg)
    );
    
    if (isIgnorable) {
      console.warn('Ignorable DOM error caught:', error);
      return { hasError: false, error: null };
    }
    
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error for debugging but don't crash the app for DOM errors
    const ignorableErrors = [
      'removeChild',
      'insertBefore', 
      'appendChild',
      'NotFoundError'
    ];
    
    const isIgnorable = ignorableErrors.some(msg => 
      error?.message?.includes(msg) || error?.toString()?.includes(msg)
    );
    
    if (isIgnorable) {
      console.warn('DOM manipulation error (safe to ignore):', error);
      // Reset the error state to keep the app running
      this.setState({ hasError: false, error: null });
      return;
    }
    
    console.error('Error caught by boundary:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-stone-50 p-4">
          <div className="text-center max-w-md">
            <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-amber-100 flex items-center justify-center">
              <AlertTriangle className="w-10 h-10 text-amber-600" />
            </div>
            <h1 className="text-2xl font-bold text-stone-900 mb-2">
              Algo salió mal
            </h1>
            <p className="text-stone-600 mb-6">
              Ha ocurrido un error inesperado. Por favor, recarga la página para continuar.
            </p>
            <Button onClick={this.handleReset} className="gap-2">
              <RefreshCw className="w-4 h-4" />
              Recargar página
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
